import React from "react";

export default function NewUsersIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0002 14C12.0002 12.5855 11.4383 11.229 10.4381 10.2288C9.43787 9.22857 8.08132 8.66667 6.66683 8.66667M6.66683 8.66667C5.25234 8.66667 3.89579 9.22857 2.89559 10.2288C1.8954 11.229 1.3335 12.5855 1.3335 14M6.66683 8.66667C8.50778 8.66667 10.0002 7.17428 10.0002 5.33333C10.0002 3.49238 8.50778 2 6.66683 2C4.82588 2 3.3335 3.49238 3.3335 5.33333C3.3335 7.17428 4.82588 8.66667 6.66683 8.66667ZM14.6668 13.3333C14.6668 11.0867 13.3335 9 12.0002 8C12.4384 7.67118 12.7889 7.23939 13.0205 6.74285C13.2522 6.2463 13.3578 5.70031 13.3282 5.1532C13.2985 4.60609 13.1344 4.07472 12.8505 3.60613C12.5665 3.13754 12.1714 2.74617 11.7002 2.46667"
        stroke="#14B8A6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
